import React from 'react'

const SummaryHeader: React.FC = () => {
    return (
        <div className="text-start">
            <p className="fw-bold">Summary</p>
        </div>
    )
}

export default SummaryHeader